/**
 * @returns {object}
 */
const getDefaultState = () => ({
  invitations: [],
  roles: []
})

export default getDefaultState
